export default {"src":"/_next/static/media/home-recycle-icon.ae8b1946.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};